<template>
    <div ref="wuliureport" id="wuliureport">

    </div>
</template>
<script>
export default {
    data() {
        return {
            colors: ["#41c733", "#2d8cf0", "#ef5a34", "#21c2d0"],
            myData: [
                ["报警类型", "应收金额", "应付金额", "已收金额", "已付金额"],
                ["2023-01", 12, 14, 16],
                ["2023-02", 10, 8, 5],
                ["2023-03", 12, 7, 20],
                ["2023-04", 12, 14, 16],
                ["2023-05", 10, 8, 5],
                ["2023-06", 12, 7, 20],
                ["2023-07", 12, 14, 16],
                ["2023-08", 10, 8, 5],
                ["2023-09", 12, 7, 20],
                ["2023-10", 12, 14, 16],
                ["2023-11", 10, 8, 5],
                ["2023-12", 12, 7, 20],
            ],
            series: [
                //系列[


                /* {
                     type: "bar",
                     yAxisIndex: 0,
                     showBackground: true,
                     backgroundStyle: {
                         color: colors[2],
                         opacity: 0.2,
                     },
                 },
                  {
                     type: "bar",
                     yAxisIndex: 0,
                     showBackground: true,
                     backgroundStyle: {
                         color: colors[3],
                         opacity: 0.2,
                     },
                 }, */
                //{ type: "bar", color: ["#8d8d8d"] },
            ],
        }
    },
    methods: {
        reach(v) {
            this.myData = v;
            this.series = [];
            for (let i = 0; i < v[0].length - 1; i++) {
                this.series.push({
                    type: "bar",
                    yAxisIndex: 0,
                    showBackground: true,
                    backgroundStyle: {
                        color: this.colors[i],
                        opacity: 0.2,
                    },
                },)

            }
            this.drawBar();
        },
        drawBar() {
            var that = this;
            //this.chart = this.echarts.init(document.getElementById("wuliureport"));
            this.chart = this.echarts.init(this.$refs.wuliureport);

            this.option = {
                color: this.colors,
                backgroundColor: "",
                /* title: {
                  text: "车辆状况看板"
                }, */
                grid: {
                    x: 50,
                    y: 60,
                    x2: 50,
                    y2: 20, //距离下边的距离
                },
                legend: {
                    right: 0, //图例组件离右边的距离
                    // orient: "vertical", //布局  纵向布局
                    orient: "horizontal", //布局  纵向布局
                    width: 350, //图行例组件的宽度,默认自适应
                    x: "right", //图例显示在右边
                    itemWidth: 10, //图例标记的图形宽度
                    itemHeight: 10, //图例标记的图形高度
                    textStyle: {
                        //图例文字的样式
                        color: "#dataModal",
                        fontSize: 12,
                    },
                },
                tooltip: {
                    //工具提示
                    left: 20,
                    formatter: function (val) {
                        return (
                            val.seriesName + "（" + val.value[val.seriesIndex + 1] + "）"
                        );
                    },
                },
                dataset: {
                    source: this.myData,
                },
                xAxis: { type: "category" },
                yAxis: [
                    {
                        type: "value",
                        name: "",
                        position: "left",
                        alignTicks: true,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: this.colors[0],
                            },
                        },
                        axisLabel: {
                            formatter: "{value} ",
                        },
                    },
                    /* {
                         type: "value",
                         name: "已收已付/元",
                         position: "right",
                         right: 100,
                         alignTicks: true,
                         axisLine: {
                             show: true,
                             lineStyle: {
                                 color: colors[1],
                             },
                         },
                         axisLabel: {
                             formatter: "{value} ",
                         },
                     },
                      {
                       type: "value",
                       name: "bbb",
                       position: "right",
                       offset: 50,
                       alignTicks: true,
                       axisLine: {
                         show: true,
           
                         lineStyle: {
                           color: colors[2],
                         },
                       }, 
                       axisLabel: {
                         formatter: "{value} ",
                       },
                     },*/
                ],
                series: this.series
            };
            this.chart.setOption(this.option);

            this.chart.resize();
        },
    },
    mounted() {
        //this.drawBar();
    }
}
</script>
<style>
#wuliureport {
    width: 100%;
    height: 240px;
    background: #e0ecff;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/report/echart.vue